const Twitter = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0272 8.19017L17.2684 0.807617H14.9858L9.97369 6.74558L5.63993 0.807617H0.172852L7.29203 10.4409L0.60383 18.3581H2.88644L8.3615 11.8854L13.1422 18.3581H18.4576L11.0272 8.19017ZM2.59911 2.02873H5.00144L15.9675 17.0413H13.6849L2.59911 2.02873Z"
        fill="white"
      />
    </svg>
  );
};
export default Twitter;
